import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import NavBar from "./NavBar";
import AlertDialog from "./AlertDialog";
import { AlertDialogConfigs } from "../../classes/AlertConfig";
import NotificationIcon from "../../assets/icons/notification-solid";
import NotificationsPopup, { NotificationType } from "./NotificationsPopup";
import { Badge } from "@mui/material";
import { fetchNotifications } from "../../services/firebase";

function getGreeting(): string {
  const currentHour = new Date().getHours();

  // if (currentHour >= 5 && currentHour < 12) {
  //   return "Goedemorgen";
  //   // return "Good Morning";
  // } else if (currentHour >= 12 && currentHour < 18) {
  //   return "Goedemiddag";
  //   // return "Good Afternoon";
  // } else if (currentHour >= 18 && currentHour < 21) {
  //   return "Goedeavond";
  //   // return "Good Evening";
  // } else {
  //   return "Welterusten";
  //   // return "Good Night";
  // }

  return "Welcome Back";
}
interface HeaderProps {
  onClickClose?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onClickClose }) => {
  const navigate = useNavigate();
  const greetingText: string = getGreeting();
  const { currentUser, getCurrentUser, logOut } = useContext(GlobalContext);

  let [thisAlertConfig, setThisAlertConfig] = useState<AlertDialogConfigs>({
    isOpen: false,
    title: "",
    message: "",
    secondaryBtnText: "",
    primaryBtnText: "",
    primaryBtnAction: logOut,
  });

  const openProfile = () => {
    navigate("/profile");
  };

  const getFirstWord = (str: string): string => {
    return str.split(" ")[0] || "";
  };

  useEffect(() => {
    if (getCurrentUser() == null) {
      navigate("/");
    }
    // console.log("Current User: ", getCurrentUser());
  }, [getCurrentUser, navigate]);

  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState<NotificationType[]>([]);

  const openNotifications = () => {
    setShowNotifications(true);
  };

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        // setLoading(true);
        const invites = await fetchNotifications(currentUser.id);
        console.log("invites: ", invites);
        setNotifications(invites);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        // setLoading(false);
      }
    };

    loadNotifications();
  }, [currentUser]);

  return (
    <>
      <div className="header-container px-6 mt-8">
        <div className="w-full flex justify-between items-center">
          <div className="greatings-container">
            <h1 className="text-[#A7A6AB] opacity-8 text-[1.3em]">
              {greetingText},
            </h1>
            <h2 className="text-[#1B1B1B] text-[1.3em]">
              Hey, {getFirstWord(currentUser?.userName)}
            </h2>
          </div>

          <div className="flex justify-center items-center">
            <button
              className="w-full flex items-center justify-center rounded-full cursor-pointer mr-4"
              type="submit"
              // onClick={openNotifications}
            >
              <Badge
                badgeContent={notifications.length}
                color="error"
                onClick={openNotifications}
                className="cursor-pointer"
              >
                <NotificationIcon size={28} color="#3a9437a2" />
              </Badge>
            </button>

            <img
              className="profile-avatar transition-all duration-200 ease-in-out"
              onClick={openProfile}
              src={currentUser.profilePicUrl}
              alt=""
            />
          </div>
        </div>
      </div>

      {showNotifications && (
        <NotificationsPopup
          userId={currentUser.id}
          notifications={notifications}
          setNotifications={setNotifications}
          showPopup={showNotifications}
          setShowPopup={setShowNotifications}
        />
      )}
      <AlertDialog alertConfig={thisAlertConfig} />
    </>
  );
};

export default Header;
